import { Link } from "@tanstack/react-router";
import { AlertTriangle, Info, Wrench, X } from "lucide-react";
import { useEffect, useState } from "react";
import { currentIncident, type IncidentSeverity } from "@/lib/status";

const STORAGE_KEY = "lendytrack.status.dismissed";

const tone: Record<IncidentSeverity, { bg: string; icon: typeof Info }> = {
  info: { bg: "bg-accent text-accent-foreground", icon: Info },
  maintenance: { bg: "bg-warning text-warning-foreground", icon: Wrench },
  degraded: { bg: "bg-warning text-warning-foreground", icon: AlertTriangle },
  outage: { bg: "bg-danger text-danger-foreground", icon: AlertTriangle },
  resolved: { bg: "bg-success text-success-foreground", icon: Info },
};

export function StatusBanner() {
  const [dismissed, setDismissed] = useState(true);
  const incident = currentIncident;

  useEffect(() => {
    if (!incident) return;
    try {
      setDismissed(localStorage.getItem(STORAGE_KEY) === incident.id);
    } catch {
      setDismissed(false);
    }
  }, [incident]);

  if (!incident || dismissed) return null;
  const t = tone[incident.severity];
  const Icon = t.icon;


  return (
    <div className={`${t.bg} relative z-50`}>
      <div className="mx-auto flex max-w-7xl items-start gap-3 px-6 py-2.5 text-sm">
        <Icon className="mt-0.5 h-4 w-4 shrink-0" />
        <div className="flex-1">
          <span className="font-semibold">{incident.title}</span>
          <span className="opacity-90"> — {incident.message} </span>
          <Link to="/status" className="font-semibold underline underline-offset-2">
            View status
          </Link>
        </div>
        <button
          aria-label="Dismiss"
          onClick={() => {
            try {
              localStorage.setItem(STORAGE_KEY, incident.id);
            } catch {}
            setDismissed(true);
          }}
          className="rounded-md p-1 hover:bg-black/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

    </div>
  );
}
